<template>
  <div class="pregled-vsebine">
    <div class="brez-izbirnika pregled-vsebine" id="PregledVsebineContent">
      <div class="vsebina-postavitev">
        <div class="odmik-vsebine">
          <div>
            <div>
              <p class="open-sans-30pt">
                Uporabniki in pravice
              </p>
            </div>
            <div style="padding-top: 10px">
              <el-tabs type="border-card" @tab-click="HandleTabClick" :value="aktivnaStevilkaStrani">
                <el-tab-pane
                  label="Dodaj pravice"
                  name="t2" ref="t2"
                  v-if="this.seznamNarocnin.length !== 0 &&
                    (this.HasPermission('PRIKLJUCKI', true) || this.HasPermission('PRIKLJUCEK_OTT_PODATKI', true))">
                  <div v-if="activetab === 't2'">
                    <Uporabniki />
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Dodeljene pravice" name="t1" ref="t1" v-if="seznamNarocnin.length !== 0">
                  <div v-if="activetab === 't1'">
                    <DodeljenePravice v-on:dodeliPravico="activetab = 't2'; aktivnaStevilkaStrani = 't2'" />
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Sprejete pravice" name="t3" ref="t3">
                  <div v-if="activetab === 't3'">
                    <SprejetePravice v-on:osveziMeni="OsveziMeniInRoute" />
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {Tabs, TabPane} from 'element-ui'
import Uporabniki from './UporabnikiInPravice/Uporabniki'
import DodeljenePravice from './UporabnikiInPravice/DodeljenePravice'
import SprejetePravice from './UporabnikiInPravice/SprejetePravice'
import {GetPodatkiIzbirnika} from '../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika'
import MenuAndRoutesBuilder from '../../../../assets/js/menuAndRoutesBuilder'
import PermissionComponent from '../GlobalneKomponente/PermissionComponent'

export default {
  name: 'UporabnikiInpravice',
  props: {
    izbranaNarocnina: {
      type: String,
      default: 'default'
    }
  },
  mixins: [GetPodatkiIzbirnika],
  data () {
    return {
      clientAgent: null,
      activetab: 't1',
      seznamNarocnin: [],
      aktivnaStevilkaStrani: 't1',
      menuAndRoutesBuilder: MenuAndRoutesBuilder.getInstance()
    }
  },
  components: {
    PermissionComponent,
    SprejetePravice,
    DodeljenePravice,
    Uporabniki,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.PridobiPodatkeNarocnin()
  },
  methods: {
    HandleTabClick (tab) {
      this.activetab = tab.name
      this.aktivnaStevilkaStrani = tab.name
    },
    PridobiPodatkeNarocnin () {
      let param = {}
      param.vmesnik = this
      this.PridobiPodatkeIzbirnika(param)
    },
    PrenosniPodatki (seznam) {
      this.seznamNarocnin = []
      for (const index in seznam.data) {
        if (typeof seznam.data[index].id_stranka_sap !== 'undefined') {
          this.seznamNarocnin.push(seznam.data[index])
        }
      }
      if (this.seznamNarocnin.length === 0) {
        this.aktivnaStevilkaStrani = 't3'
        this.activetab = 't3'
      } else if (
        this.HasPermission('PRIKLJUCKI', true) ||
        this.HasPermission('PRIKLJUCEK_OTT_PODATKI', true)
      ) {
        this.aktivnaStevilkaStrani = 't2'
        this.activetab = 't2'
      }
    },
    OsveziMeniInRoute () {
      this.menuAndRoutesBuilder.RetrieveRoutesAndSideBarLinks()
    }
  }
}
</script>
<style scoped src="../../../../../static/css/moj_profil/narocnine.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/UporabnikiInPravice.vue